import { IconChevronDown, IconChevronUp } from '@moovly/ui';
import * as React from 'react';
import { TableHeadCol } from '../../components/Table';
import { simpleSort } from '../../utils/object';
import './SortableTableHeader.scss';

const useSortableTableHeader = (data: any[], defaultSort?: string) => {
  const [sort, setSort] = React.useState<{
    by: string | null;
    direction: 'asc' | 'desc';
  }>({
    by: defaultSort || null,
    direction: 'asc',
  });
  const sortedData = React.useMemo(() => simpleSort(data, sort), [data, sort]);
  const SortableTableHeader: React.FC<{ sortBy: string; label: string; isDefault?: boolean }> = React.memo(
    ({ sortBy, label }) => {
      const handleSort = React.useCallback(() => {
        setSort({
          by: sortBy,
          direction: sort.by === sortBy && sort.direction === 'asc' ? 'desc' : 'asc',
        });
      }, [sortBy]);

      return (
        <TableHeadCol className="SortableTableHeader" onClick={handleSort}>
          <span>
            {label}
            <div>
              {sort.by === sortBy && sort.direction === 'desc' && <IconChevronDown />}
              {sort.by === sortBy && sort.direction === 'asc' && <IconChevronUp />}
            </div>
          </span>
        </TableHeadCol>
      );
    }
  );

  return { SortableTableHeader: SortableTableHeader, sortedData };
};

export default useSortableTableHeader;
